import { USER_TYPE_ENUM } from "./ToddleAnalyticsConstants";
import {
  OVERALL_PERFORMANCE_BY_YEARGROUP,
  OVERALL_PERFORMANCE_BY_SUBJECT,
  OVERALL_PERFORMANCE_BY_CLASS,
  OVERALL_PERFORMANCE_BY_STAFF,
  OVERALL_PERFORMANCE_BY_STUDENT,
  ASSIGNMENT_PERFORMANCE_BY_STUDENT,
  SUBJECT_PERFORMANCE_BY_STUDENT,
  CLASS_PERFORMANCE_BY_STAFF,
  STUDENT_PERFORMANCE_BY_CLASS,
  ASSIGNMENT_PERFORMANCE_BY_CLASS,
  CLASS_PERFORMANCE_BY_SUBJECT,
  STUDENT_PERFORMANCE_BY_SUBJECT,
  STUDENT_OVERALL_PERFORMANCE_BY_YEARGOUP,
  STUDENT_SUBJECTWISE_PERFORMANCE_BY_YEARGROUP,
  SUBJECT_PERFORMANCE_BY_YEARGROUP,
  INCIDENT_OVERVIEW_BY_CATEGORY,
  INCIDENT_DETAILED_BY_CATEGORY,
  INCIDENT_OVERVIEW_BY_GRADE,
  INCIDENT_DETAILED_BY_GRADE,
  INCIDENT_OVERVIEW_BY_STUDENT,
  INCIDENT_DETAILED_BY_STUDENT,
  STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW,
  STUDENT_POSITIVE_INCIDENTS_OVERVIEW,
  PLANNING_USAGE_BY_GRADE,
  PLANNING_USAGE_BY_CLASS,
  PLANNING_USAGE_BY_STAFF,
  PORTFOLIO_USAGE_BY_GRADE,
  PORTFOLIO_USAGE_BY_CLASS,
  PORTFOLIO_USAGE_BY_STAFF,
  PORTFOLIO_USAGE_BY_STUDENT,
  ASSIGNMENTS_USAGE_BY_GRADE,
  ASSIGNMENTS_USAGE_BY_CLASS,
  ASSIGNMENTS_USAGE_BY_STAFF,
  ASSIGNMENTS_USAGE_BY_STUDENT,
  MESSAGING_USAGE_BY_STAFF,
  MESSAGING_USAGE_BY_STUDENT,
  MESSAGING_USAGE_BY_FAMILY,
  DETAILED_ATTENDANCE_BY_STUDENT,
  ATTENDANCE_OVERVIEW_BY_STUDENT,
  ABSENT_STUDENTS_BY_GRADE,
  DETAILED_STUDENTS_BY_GRADE,
  ATTENDANCE_OVERVIEW_BY_GRADE,
  ABSENT_STUDENTS_BY_CLASS,
  DETAILED_STUDENTS_BY_CLASS,
  ATTENDANCE_OVERVIEW_BY_CLASS,
  ABSENT_STUDENTS_OVERVIEW,
  DETAILED_STUDENTS_OVERVIEW,
  OVERVIEW_USAGE_BY_GRADE,
  OVERVIEW_USAGE_BY_CLASS,
  OVERVIEW_USAGE_BY_STAFF,
  OVERVIEW_USAGE_BY_FAMILY,
  OVERVIEW_USAGE_BY_LEARNING_COURSE,
  OVERVIEW_USAGE_BY_STUDENT,
  OVERALL_PERFORMANCE_BY_LEARNING_COURSE,
  STUDENT_PERFORMANCE_BY_LEARNING_COURSE,
  CLASS_PERFORMANCE_BY_LEARNING_COURSE,
} from "./TableConstants";

export const DASHBOARD_TITLE_MAP = {
  [USER_TYPE_ENUM.parent]: "FamilyEngagement",
  [USER_TYPE_ENUM.student]: "StudentEngagement",
  [USER_TYPE_ENUM.staff]: "StaffEngagement",
  [OVERALL_PERFORMANCE_BY_YEARGROUP]: "PerformanceByGrade",
  [OVERALL_PERFORMANCE_BY_SUBJECT]: "PerformanceBySubject",
  [OVERALL_PERFORMANCE_BY_CLASS]: "PerformanceByClass",
  [OVERALL_PERFORMANCE_BY_STAFF]: "PerformanceByStaff",
  [OVERALL_PERFORMANCE_BY_STUDENT]: "PerformanceByStudent",
  [INCIDENT_OVERVIEW_BY_CATEGORY]: "IncidentsByCategory",
  [INCIDENT_OVERVIEW_BY_GRADE]: "IncidentsByGrade",
  [INCIDENT_OVERVIEW_BY_STUDENT]: "IncidentsByStudent",
  [STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW]:
    "Negative/Neutral_IncidentsByStudent",
  [STUDENT_POSITIVE_INCIDENTS_OVERVIEW]: "Positive_IncidentsByStudent",
  [ATTENDANCE_OVERVIEW_BY_STUDENT]: "AttendanceByStudent",
  [ATTENDANCE_OVERVIEW_BY_GRADE]: "AttendanceByGrade",
  [ATTENDANCE_OVERVIEW_BY_CLASS]: "AttendanceByClass",
  [ABSENT_STUDENTS_OVERVIEW]: "AbsentStudentsOverview",
  [DETAILED_STUDENTS_OVERVIEW]: "DetailedAttendanceOverview",
  [OVERALL_PERFORMANCE_BY_LEARNING_COURSE]: "PerformanceByLearningCourse",
  [STUDENT_PERFORMANCE_BY_LEARNING_COURSE]: "PerformanceByStudent",
  [CLASS_PERFORMANCE_BY_LEARNING_COURSE]: "PerformanceByClass",
};

export const CHART_TITLE_MAP = {
  [OVERALL_PERFORMANCE_BY_YEARGROUP]: "Overview",
  [OVERALL_PERFORMANCE_BY_SUBJECT]: "Overview",
  [OVERALL_PERFORMANCE_BY_CLASS]: "Overview",
  [OVERALL_PERFORMANCE_BY_STAFF]: "Overview",
  [OVERALL_PERFORMANCE_BY_STUDENT]: "Overview",
  [OVERALL_PERFORMANCE_BY_LEARNING_COURSE]: "Overview",
  [ASSIGNMENT_PERFORMANCE_BY_STUDENT]: "PerformanceByAssignment",
  [SUBJECT_PERFORMANCE_BY_STUDENT]: "PerformanceBySubject",
  [CLASS_PERFORMANCE_BY_STAFF]: "PerformanceByClass",
  [STUDENT_PERFORMANCE_BY_CLASS]: "PerformanceByStudent",
  [ASSIGNMENT_PERFORMANCE_BY_CLASS]: "PerformanceByAssignment",
  [CLASS_PERFORMANCE_BY_SUBJECT]: "PerformanceByClass",
  [STUDENT_PERFORMANCE_BY_SUBJECT]: "PerformanceByStudent",
  [STUDENT_OVERALL_PERFORMANCE_BY_YEARGOUP]: "PerformanceByStudent",
  [STUDENT_SUBJECTWISE_PERFORMANCE_BY_YEARGROUP]: "PerformanceByStudent",
  [SUBJECT_PERFORMANCE_BY_YEARGROUP]: "PerformanceBySubject",
  [INCIDENT_OVERVIEW_BY_CATEGORY]: "CategoryOverview",
  [INCIDENT_OVERVIEW_BY_GRADE]: "GradeOverview",
  [INCIDENT_OVERVIEW_BY_STUDENT]: "StudentOverview",
  [STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW]: "StudentOverview",
  [STUDENT_POSITIVE_INCIDENTS_OVERVIEW]: "StudentOverview",
  [INCIDENT_DETAILED_BY_CATEGORY]: "AllIncidents",
  [INCIDENT_DETAILED_BY_GRADE]: "AllIncidents",
  [INCIDENT_DETAILED_BY_STUDENT]: "AllIncidents",
  [OVERVIEW_USAGE_BY_GRADE]: "DetailedOverviewUsage",
  [OVERVIEW_USAGE_BY_LEARNING_COURSE]: "DetailedOverviewUsage",
  [OVERVIEW_USAGE_BY_CLASS]: "DetailedOverviewUsage",
  [OVERVIEW_USAGE_BY_STAFF]: "DetailedOverviewUsage",
  [OVERVIEW_USAGE_BY_STUDENT]: "DetailedOverviewUsage",
  [OVERVIEW_USAGE_BY_FAMILY]: "DetailedOverviewUsage",
  [PLANNING_USAGE_BY_GRADE]: "DetailedPlanningUsage",
  [PLANNING_USAGE_BY_CLASS]: "DetailedPlanningUsage",
  [PLANNING_USAGE_BY_STAFF]: "DetailedPlanningUsage",
  [PORTFOLIO_USAGE_BY_GRADE]: "DetailedPortfolioUsage",
  [PORTFOLIO_USAGE_BY_CLASS]: "DetailedPortfolioUsage",
  [PORTFOLIO_USAGE_BY_STAFF]: "DetailedPortfolioUsage",
  [PORTFOLIO_USAGE_BY_STUDENT]: "DetailedPortfolioUsage",
  [ASSIGNMENTS_USAGE_BY_GRADE]: "DetailedAssignmentsUsage",
  [ASSIGNMENTS_USAGE_BY_CLASS]: "DetailedAssignmentsUsage",
  [ASSIGNMENTS_USAGE_BY_STAFF]: "DetailedAssignmentsUsage",
  [ASSIGNMENTS_USAGE_BY_STUDENT]: "DetailedAssignmentsUsage",
  [MESSAGING_USAGE_BY_STAFF]: "DetailedMessagingUsage",
  [MESSAGING_USAGE_BY_STUDENT]: "DetailedMessagingUsage",
  [MESSAGING_USAGE_BY_FAMILY]: "DetailedMessagingUsage",
  [DETAILED_ATTENDANCE_BY_STUDENT]: "DetailedAttendance",
  [ABSENT_STUDENTS_BY_GRADE]: "AbsentStudents",
  [DETAILED_STUDENTS_BY_GRADE]: "DetailedStudents",
  [ABSENT_STUDENTS_BY_CLASS]: "AbsentStudents",
  [DETAILED_STUDENTS_BY_CLASS]: "DetailedStudents",
};

export const FILTER_MAP = {
  [OVERVIEW_USAGE_BY_GRADE]: "bygrade",
  [OVERVIEW_USAGE_BY_LEARNING_COURSE]: "bycourse",
  [OVERVIEW_USAGE_BY_CLASS]: "byclass",
  [OVERVIEW_USAGE_BY_STAFF]: "bystaff",
  [OVERVIEW_USAGE_BY_STUDENT]: "bystudent",
  [OVERVIEW_USAGE_BY_FAMILY]: "byfamily",
  [PLANNING_USAGE_BY_GRADE]: "bygrade",
  [PLANNING_USAGE_BY_CLASS]: "byclass",
  [PLANNING_USAGE_BY_STAFF]: "bystaff",
  [PORTFOLIO_USAGE_BY_GRADE]: "bygrade",
  [PORTFOLIO_USAGE_BY_CLASS]: "byclass",
  [PORTFOLIO_USAGE_BY_STAFF]: "bystaff",
  [PORTFOLIO_USAGE_BY_STUDENT]: "bystudent",
  [ASSIGNMENTS_USAGE_BY_GRADE]: "bygrade",
  [ASSIGNMENTS_USAGE_BY_CLASS]: "byclass",
  [ASSIGNMENTS_USAGE_BY_STAFF]: "bystaff",
  [ASSIGNMENTS_USAGE_BY_STUDENT]: "bystudent",
  [MESSAGING_USAGE_BY_STAFF]: "bystaff",
  [MESSAGING_USAGE_BY_STUDENT]: "bystudent",
  [MESSAGING_USAGE_BY_FAMILY]: "byfamily",
};
